<template>
    <div class="file-upload row">

        <vue-dropzone ref="myVueDropzone" id="dropzone"
                      @vdropzone-success="uploaded"
                      @vdropzone-error="failed"
                      @vdropzone-canceled="failed"
                      @vdropzone-sending="sendingEvent"
                      tag="section"
                      class="col-12"
                      v-bind="dropzoneOptions"
                      :useCustomSlot=true
                      :options="dropzoneOptions">
          <div class="drop-zone">
            <font-awesome-icon icon="cloud-upload-alt" size="2x"/>
            <br>
            <button class="btn btn-sm">{{t('Upload Files')}}</button>
          </div>
        </vue-dropzone>

    </div>
</template>
<script>

    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        components: {

            vueDropzone: vue2Dropzone,
        },
        props: {
            apiUrl: {
                type: String,
            },
            acceptedFileTypes: {
                type: Array,
                default: function () {
                    return [
                        'image/*',
                        'application/pdf',
                        'application/vnd.ms-excel',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'application/rtf',
                        'application/x-rar-compressed',
                        'application/octet-stream',
                        'application/zip',
                        'multipart/x-zip',
                        'application/x-zip-compressed',
                    ];
                },
            }
        },
        mounted() {
            // this.options.acceptedFileTypes = this.acceptedFileTypes;
            // this.options.driverOptions.url = this.apiUrl;
            // this.dropzoneOptions.url = this.apiUrl;
        },
        methods: {
            uploaded(file, response) {
                this.$emit('addedFile');
                this.clean(3000, file);
            },
            failed(file) {
                const elements = document.querySelectorAll('.dz-error-message span');
                const lastElement = elements[elements.length - 1];
                const parent = lastElement.parentElement.parentElement;
                parent.className += ' dz-error';
                if ((file.size/1000000) > this.dropzoneOptions.maxFilesize) {
                    lastElement.textContent = this.t('Prilis velky subor. Subor sa nenahral. Prosim zmensite subor a skuste este raz.');
                } else {
                    lastElement.textContent = this.t('Súbor sa nepodarilo nahrať, skuste to znova.');
                }

                this.clean(10000, file);
            },
            sendingEvent (file, xhr, formData) {
                var self = this;
                var files = file;
                xhr.ontimeout = function (e) {
                    self.failed(files);
                };
            },
            clean(time, file) {
                var self = this;
                setTimeout(function () {
                    self.$refs.myVueDropzone.removeFile(file);
                },time);
            }
        },
        data() {
            return {
                dropzoneOptions: {
                    url: this.apiUrl,
                    acceptedFile: this.acceptedFileTypes,
                    clickable: true,
                    method: 'post',
                    withCredentials: true,
                    maxFiles: 4,
                    timeout: 30000,
                    maxFilesize: 5,
                    uploadMultiple: true,
                    headers: {
                        'Authorization': localStorage.getItem('csrf'),
                        'Cache-Control': null,
                        'X-Requested-With': null,
                        'Accept': null
                    }
                },
            }
        },

    }
</script>
<style lang="scss">
    .v-transmit__upload-area {
        border-width: 0 ! important;
        min-height: 0 ! important;
    }

    #dropzone {
        padding: 20px 20px 15px;
        border: 1px dashed #cdd2d8;
        text-align: center;
        border-radius: 4px;
    }

    #dropzone .dz-preview {
      height: 25px;
      width: 100%;
      margin: 0;
      margin-bottom: 20px;
    }

    #dropzone .dz-preview:last-of-type {
      margin-bottom: 5px;
    }

    #dropzone .dz-preview .dz-image img:not([src]) {
      width: 100%;
    }

    #dropzone .dz-preview .dz-image img {
      height: 100%;
      width: 100%;
    }

    #dropzone .dz-preview .dz-progress {
      left: 80%;
    }

    #dropzone .dz-preview.dz-error .dz-error-message {
      top: 100%;
      border-radius: 0;
    }

    .file-row {
        min-height: 50px;
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid rgba(0, 0, 0, 0.125);
        color: #000;

        &:hover {
            color: #000;
        }

        .file-col-image {
            img {
                object-fit: cover;
                height: 100%;
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/file-upload.vue